export default __webpack_public_path__ + "static/media/martin.d5691145.jpg";